import fetchAll from './fetchAll'
import onRequestDelete from './onRequestDelete'

const TabletAction = {
  fetchAll,
  onRequestDelete
}

export default TabletAction
